export const nodeConfigs: Record<string, any> = {
  authentication: {
    extraData: {
      configData: {},
      response: null,
    },
  },

  ifElseNode: {
    extraData: {
      label: "If Else",
      uid: "",
      title: "",
      description: "",
      conditions: {
        options: {
          caseSensitive: true,
          leftValue: "",
          typeValidation: "strict",
          version: 3,
        },
        conditions: [],
        combinator: "and",
      },
      looseTypeValidation: false,
      options: {},
      response: null,
    },
  },

  switchNode: {
    extraData: {
      label: "Switch",
      uid: "",
      title: "",
      description: "",
      mode: "rules",
      rules: {
        values: [],
      },
      looseTypeValidation: true,
      options: {},
      response: null,
    },
  },

  pluginSettings: {
    extraData: {
      formTitle: "",
      formFields: [],
      response: null,
    },
  },

  requestBlock: {
    extraData: {
      label: "HTTP Request",
      uid: "",
      title: "",
      description: "",
      response: null,
    },
  },

  editFields: {
    extraData: {
      label: "Edit Fields",
      uid: "",
      title: "",
      description: "",
      fields: [],
      mode: "manual",
      includeOtherInputFields: false,
      globalFieldType: "fixed",
      inputFieldsMode: "all",
      inputFieldsList: "",
      response: null,
    },
  },

  splitOutNode: {
    extraData: {
      label: "Split Out",
      uid: "",
      title: "",
      description: "",
      fieldsToSplitOut: [""],
      include: "noOtherFields",
      // Don't include fieldsToInclude in initial config - only added when mode is selectedOtherFields
      options: {},
      response: null,
      storedParameters: {
        fieldToSplitOut: "",
        include: "noOtherFields",
        options: {
          disableDotNotation: false,
          destinationFieldName: "",
        },
        // fieldsToInclude is NOT included here - only added for selectedOtherFields mode
      },
    },
  },

  aggregateNode: {
    extraData: {
      label: "Aggregate",
      uid: "",
      title: "",
      description: "",
      aggregateMode: "collect",
      mergeStrategy: "overwrite",
      fieldsToAggregate: [""],
      options: {},
      response: null,
    },
  },

  mergeNode: {
    extraData: {
      label: "Merge",
      uid: "",
      title: "",
      description: "",
      mode: "append",
      numberOfInputs: 2,
      combineBy: "combineByPosition",
      fieldNamesMatch: true,
      fieldsToMatch: "",
      outputType: "keepMatches",
      outputDataFrom: "both",
      disableDotNotation: undefined,
      fuzzyCompare: undefined,
      response: null,
    },
  },

  sortNode: {
    extraData: {
      label: "Sort",
      uid: "",
      title: "",
      description: "",
      mode: "simple",
      fields: [],
      customCode: "",
      order: "asc",
      nullsLast: true,
      disableDotNotation: true,
      response: null,
    },
  },

  limitNode: {
    extraData: {
      label: "Limit",
      uid: "",
      title: "",
      description: "",
      maxItems: 10,
      keepItemsFrom: "start",
      response: null,
    },
  },

  savelogs: {
    extraData: {
      label: "Save Logs",
      uid: "",
      title: "",
      description: "",
      logMappings: [],
      response: null,
    },
  },

  savedatalist: {
    extraData: {
      label: "Datalist",
      uid: "",
      title: "",
      description: "",
      datalistMappings: [],
      response: null,
    },
  },

  startNode: {
    extraData: {
      label: "Start",
      uid: "",
      title: "",
      description: "",
      response: [{}],
    },
  },

  loopOverItemsNode: {
    extraData: {
      label: "Loop Over Items",
      uid: "",
      title: "",
      description: "",
      batchSize: 1,
      reset: false,
      response: null,
    },
  },

  pythonCodeNode: {
    extraData: {
      label: "Python Code",
      uid: "",
      title: "",
      description: "",
      code: "",
      mode: "runOnceForAllItems",
      continueOnFail: false,
      pythonEnv: "python3",
      response: null,
    },
  },

  functionNode: {
    extraData: {
      label: "Function",
      uid: "",
      title: "",
      description: "",
      action: "threat_lookup",
      mappingDataList: [],
      response: null,
    },
  },

  stopAndErrorNode: {
    extraData: {
      label: "Stop and Error",
      uid: "",
      title: "",
      description: "",
      errorType: "errorMessage",
      errorMessage: "HTTP request failed with status code 500",
      response: null,
    },
  },
};
